
import { UserService } from '../../../shared/user.service';
import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
declare const $: any;


@Component({
  selector: 'app-emp-master-form',
  templateUrl: './emp-master-form.component.html',
  styleUrls: ['./emp-master-form.component.css']
})
export class EmpMasterFormComponent implements OnInit {
  title="Add Employee Details";
  list : any = [];
  mode : any;
  Id :any;
  data: any = {};
  c: any = {};
  d: any = {};
  s: any = {};
  n: any = {};
  e: any = {};
a: any = {};
  Districtlist: any = {};
  Statelist: any = {};
  CATEGORYlist: any = {};
  formInvalid: boolean = false;
  //mode : string;
  EMP_ID: any;
  hide: boolean;

  Divisionlist: any={};
  Deptlist: any=[];
  Designationlist : any={};
  Divisdepartlist : any={};
  EmployeeTypelist  : any={};

  p : any={};
  SectionList: any;
  DOBempty: boolean;
  fileToUpload: File;
  photoImageUrl: any;
  userService: any;
  Image_path: string;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) {  }


  ngOnInit() {
    

   
    this.GetAllData();
    this. GetAllDivisioname();
    this.GetAlldepartymentname();
    this.c.COUNTRY='INDIA'
    // this.list;
    debugger
    
    this.route.params.subscribe(params => {
      
      this.EMP_ID = params['EMP_ID'];
      this.mode = params['mode'];

      if (this.EMP_ID > 0) {
        this.GetByIdEmployee(this.EMP_ID)
      }
      if (this.mode == 'View') {
        this.hide = true;

      }
     else if (this.mode == 'Edit') {
      this.hide = true;
    }
    });
  }

  // getEmpList(id){
  //   this.UserService.getEmpList(id).subscribe(data =>{
  //     this.list = data;
  //     console.log(this.list);
  //   })
  // }

  GetAllData() {
    debugger;

    this.data = this.UserService.GetAllDistricts();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response.Result;
        console.log("district");
        console.log(this.Districtlist)
      })

    this.data = this.UserService.GetAllStatelist();
    this.data.subscribe(
      (response: any) => {
        this.Statelist = response.Result;
        console.log("state");
        console.log(this.Statelist)
      })

      this.data = this.UserService.GetAllCategorylist();
    this.data.subscribe(
      (response: any) => {
        this.CATEGORYlist = response.Result;
        console.log("category");
        console.log(this.CATEGORYlist)
      })
      this.data = this.UserService.GetAlldepart();
      this.data.subscribe(
        (response: any) => {
          this.Deptlist = response.Result;
          console.log("Deptlist");
          console.log(this.Deptlist)
        })
    
        this.data = this.UserService.GetAllSECTIONLIST();
      this.data.subscribe(
        (response: any) => {
          this.SectionList = response.Result;
          console.log("SectionList");
          console.log(this.SectionList)
        })
    
        //for Designationlist
    
         this.data = this.UserService.GetDesignationlist();
         this.data.subscribe(
           (response: any) => {
             this.Designationlist = response.Result;
           console.log("Designationlist");
            console.log(this.Designationlist)
           })
        
           this.data = this.UserService.GetEmployeeTypelist();
           this.data.subscribe(
             (response: any) => {
               this.EmployeeTypelist = response.Result;
             console.log("EmployeeTypelist");
              console.log(this.EmployeeTypelist)
             })


           
    

 }
 GetAllDivisioname(){
  this.data = this.UserService.GetAllDivisioname();
  this.data.subscribe(
    (response: any) => {
      this.Divisdepartlist = response.Result;
      console.log("Divisdepartlist");
      console.log(this.Divisdepartlist)
    })
  }

  //for department
  GetAlldepartymentname(){
this.data = this.UserService.GetAlldepart();
this.data.subscribe(
(response: any) => {
this.Deptlist = response.Result;
console.log("Deptlist");
console.log(this.Deptlist)
})
}



CalculateAge()
{
  debugger;
  let ageofcust;
  this.DOBempty=false;
  if(this.c.DOB.length>10)
   swal('Date','Enter correct date')
  else if (this.c.DOB) {
  //convert date again to type Date
  const bdate = new Date(this.c.DOB);
  const timeDiff = Math.abs(Date.now() - bdate.getTime() );
  this.c.AGE = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  if(ageofcust<18)
  {
    swal('Warning','Customer must be greater than 18 years old',"warning");
    this.c.DOB='';
    this.c.AGE='';
    
  }
 }
}

GetByIdEmployee(EMP_ID){

  // this.DOC_NOs=DOC_NO;      
   document.getElementById('loader-spinner').style.display = "block";
       this.data = this.UserService.GetByIdEmployee(EMP_ID);
     
       this.data.subscribe(
         (response: any) => {

           this.c = response;  
     this.photoImageUrl = this.c.Photo_Upload_Path  ;
     if (this.c.DOB != null)
     this.c.DOB = ((this.c.DOB).split('T'))[0];  
     if (this.c.DATE_OF_JOIN != null)
     this.c.DATE_OF_JOIN = ((this.c.DATE_OF_JOIN).split('T'))[0];   
           console.log(this.c)    
               
           document.getElementById('loader-spinner').style.display = "none";
         },(error) => {
           document.getElementById('loader-spinner').style.display = "none";
           if (error.status == 401 || error.status == 500) {
             this.errorHandler.handleError(error);
           }
           else if (error.status == 400) {
             swal('Warning!', error.error.Message, 'warning');
           }
         });

         
 }

//upload for adhara

 //upload
 imageUploadadhara(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.UserService.uploadImageforaadhar(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Aadhar_Upload_Path');
        i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Aadhar_Upload_Path');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFUrlAdhara() {
  let imagename = null;
  try {
    imagename = document.getElementById('Aadhar_Upload_Path');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


//pan upload

imageUploadPan(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.UserService.uploadImageforaadhar(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Pan_Upload_Path');
        i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Pan_Upload_Path');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityUrlPan() {
  let imagename = null;
  try {
    imagename = document.getElementById('Pan_Upload_Path');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}




FileInputPhoto(file: FileList) {
  debugger
    
  //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {             
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
       this.photoImageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.UserService.uploadImagesFilePhoto(data);
    //this.data = this.UserService.PostEmployee(Employee.value);
    x.subscribe(
      (response) => {
        

      }, (error) => {
        let i: any = document.getElementById('Image_path');
        i.value = "";
        if (error.status == 400) {
           this.Image_path = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Image_path');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload and .jpeg,jpg or png", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getImageProofPDFUrl() {
  let imagename = null;
  try {
    imagename = document.getElementById('Image_path');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


SaveEmployee(Employee: NgForm) {

  if (Employee.invalid) {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else {
    Employee.value.Aadhar_Upload_Path = this.getFeasibilityFUrlAdhara();
    Employee.value.Pan_Upload_Path = this.getFeasibilityUrlPan();

   // Vendor.value.Company_Logo_Path = this.getFeasibilityFUrlAdhara();
    this.data = this.UserService.PostEmployee(Employee.value);
    this.data.subscribe(
      (response) => {
        Employee.reset();
        Employee.resetForm();
        Employee.form.markAsPristine();
        Employee.form.markAsUntouched();
        swal('Success!', 'Employee  Details Added Successfully .', 'success');
        this.router.navigate(['/home/employee-master']);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

    } 
  }


  UpdateEmployee(Employee: NgForm) {

    //Associate.value.AdressModel = this.AdressDetails;
  //  Associate.value.BankModel = this.bankDetails;
    this.data = this.UserService.UpdateEmployee(Employee.value, this.EMP_ID);
    this.data.subscribe(
      (response) => {
       // data.reset();
        //data.resetForm();
       // data.form.markAsPristine();
       // data.form.markAsUntouched();

        swal('Success!', 'Employee deatails updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/employee-master/employee-master-form']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }




}


// WEBPACK FOOTER //
// ./src/app/ultilities/employee-master/emp-master-form/emp-master-form.component.ts